import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Grid,
  Typography,
  IconButton,
} from "@material-ui/core";
import MuiDialogContent from "@material-ui/core/DialogContent";
import { useSelector } from "react-redux";
import { commonService } from "../../../../services/common.service";
import { ImageDialog } from "../../../auth/auth-style";
import CloseIcon from "@material-ui/icons/Close";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  imgStyle:{
    width:"70%",
    [theme.breakpoints.down("xs")]: {
      width:"100%"
    }
  },
  infoImgIcon: {
    '&:hover #infoImg':{
      boxShadow: "0px 5px 10px rgba(0,0,0,0.3)",
    },
    '&:hover #zoomIconOverlay': {
      animation: `$hoverAnimation 0.3s ${theme.transitions.easing.easeInOut}`,
      fill: theme.palette.eSecondary.base + " !important",
      transform: 'translate(0, -20px)',
    },
  },
  "@keyframes hoverAnimation": {
    "0%": {
      transform: "translate(0, 0)"
    },
    "100%": {
      transform: "translate(0, -20px)"
    },
  },
  informationTitle: {
    align: 'left',
    color: theme.palette.ePrimary.base + " !important",
    fontWeight:"Bold"
  },
  informationText: {
    color: theme.palette.eRich.base + " !important"
  },
  zoomIconOverlay: {
    position: "absolute",
    left: "auto",
    right: "auto",
    top: "auto",
    bottom: "auto",
    zIndex: "12",
    fill: theme?.palette?.eTertiary?.base + " !important",
    fontSize: "2.625rem",
    "&:hover": {
      fill: theme.palette.eSecondary.base + " !important"
    }
  }
}));

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    backgroundColor:theme.palette.ePrimary.base,
    color:theme.palette.eWhite.base,
    fontFamily:theme.typography.fontFamily
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color:theme.palette.eWhite.base
  },
});
const DialogTitle = withStyles(styles)((props) => {
  const { classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
     {props.labels}
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

export default function QuickPayInformation() {
  let classes = useStyles();
  const {t:content, ready: contentReady} = useTranslation(
    "content-E_AUTH_QUICK_PAY"
  );
  const [openDialog, setOpenDialog] = useState(false);
  const [accountIdImg, setaccountIdImg] = useState(null);
  // let labels = useSelector(
  //   (store) => store?.labels?.data?.getLabels?.USER_MANAGEMENT
  // );
  const {t:labels, ready: labelsReady} = useTranslation(
    "label-E_AUTH_QUICK_PAY"
  );
  let accountImg = useSelector(
    (store) => store?.parametersWidgets?.ParameterLookup?.CONNECTION_ID_IMAGE
  );
  useEffect(() => {
    if (accountImg) {
      commonService.getAssestUrl(accountImg).then((response) => {
        setaccountIdImg(response);
      });
    }
  }, [accountImg]);

  function handleClickOpen() {
    setOpenDialog(true);
  }
  function handleClose() {
    setOpenDialog(false);
  }
  return (
    <CardContent>
      <Grid container direction="column" spacing={3}>
        <Grid item>
          <Grid container direction="row" spacing={1}>
            <Grid item xs={6}>
              <Typography variant="subtitle1" className={classes.informationTitle}>
                {contentReady? content("E_QUICK_PAY_FIND_CONNECTION_ID").question : ""}
              </Typography>
              <Typography
                variant="subtitle2"
                className={classes.informationText}
                dangerouslySetInnerHTML={{
                  __html: contentReady? content("E_QUICK_PAY_FIND_CONNECTION_ID").answer : "",
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <IconButton aria-label="close" onClick={handleClickOpen} position="relative" className={classes.infoImgIcon}>
              <ZoomInIcon className={classes.zoomIconOverlay} id="zoomIconOverlay"></ZoomInIcon>
                <img
                  src={accountIdImg?.assetPath}
                 // alt={labels([accountIdImg?.fallBackLabelKey])}
                  className={classes.imgStyle}
                  id="infoImg"
                />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Typography variant="subtitle1" className={classes.informationTitle}>
            {contentReady? content("E_QUICK_PAY_VISIT_OUR_SERVICE").question : ""}
          </Typography>
          <Typography
            variant="subtitle2"
            className={classes.informationText}
            dangerouslySetInnerHTML={{
              __html: contentReady? content("E_QUICK_PAY_VISIT_OUR_SERVICE").answer : "",
            }}
          />
        </Grid>
      </Grid>
      <ImageDialog open={openDialog} onClose={handleClose} className={`"width100"`}>
        <DialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
          labels={labels("QUICK_PAY_VIEW_BILL")}
        ></DialogTitle>
        <MuiDialogContent>
          <img
            src={accountIdImg?.assetPath}
           // alt={labels?.[accountIdImg?.fallBackLabelKey]}
            className="rightBack"
          />
        </MuiDialogContent>
      </ImageDialog>
    </CardContent>
  );
}
